<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.chargeNo" @keyup.enter.native="queryChange" suffix-icon="el-icon-search" />
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
 
      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column v-if="system_setting.IsChargeDecoupling" :key="'right'" fixed="right" prop="operation" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.tableState==0||scope.row.tableState==2" v-preventReClick @click="generateOrder(scope.row)" class="margin-left20 color-blue">生成单据</el-button>
            </template>
          </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
        <el-table-column prop="productName" min-width="200" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName"  min-width="180" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="patientName"  min-width="80" label="患者名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="patientNo"  min-width="115" label="住院号/门诊号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="chargeCategoryName"  min-width="80" label="计费类型"></el-table-column>
        <el-table-column prop="number"  min-width="50" label="数量"></el-table-column>
        <el-table-column prop="price"  min-width="60" label="单价"></el-table-column>
        <el-table-column prop="unit"  min-width="60" label="单位">
          <template slot-scope="scope">
            {{ scope.row.unit?scope.row.unit:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="billingPrice"  min-width="70" label="计费价"></el-table-column>
 
        <el-table-column prop="amount"  min-width="60" label="小计"></el-table-column>
        <el-table-column prop="batch"  min-width="110" label="批号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mainNo"  min-width="180" label="主条码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.mainNo?scope.row.mainNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="traceNo"  min-width="220" label="溯源码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.traceNo?scope.row.traceNo:'-' }}
          </template>
        </el-table-column>
            <el-table-column prop="minTagCode"  min-width="220" label="标签码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.minTagCode?scope.row.minTagCode:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="chargeUserName" label="计费人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="chargeDeptName"  min-width="90" label="计费科室" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deptName"  min-width="90" label="执行科室"></el-table-column>
        <el-table-column prop="chargeNo" min-width="100" show-overflow-tooltip label="计费单号"></el-table-column>
        <el-table-column prop="supplierProductNo"  min-width="180" label="供应商产品编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isDistributionName"  min-width="80" label="是否集采" show-overflow-tooltip></el-table-column>
        <el-table-column prop="componentLocation"  min-width="170" label="部件部位" show-overflow-tooltip></el-table-column>
        <el-table-column prop="surgicalStentName"  min-width="170" label="手术" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.surgicalStentName?scope.row.surgicalStentName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseOrderNo"  min-width="170" label="采购订单" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stockCategoryName"  min-width="100" label="库存类型" show-overflow-tooltip></el-table-column>
        <el-table-column prop="acceptNo"  min-width="170" label="采购入(退)库单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="applyNo"  min-width="170" label="请领出(退)库单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deptNo"  min-width="170" label="科室入(退)库单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="collectNo"  min-width="170" label="领用出(退)库单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdTime" min-width="170" label="核销时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"  min-width="200"></el-table-column>
        <el-table-column v-if="system_setting.IsChargeDecoupling" :key="'tableStateName'" prop="tableStateName" show-overflow-tooltip label="补单状态"  min-width="200"></el-table-column>
        <el-table-column v-if="system_setting.IsChargeDecoupling" :key="'failureNumber'" prop="failureNumber" show-overflow-tooltip label="失败次数"  min-width="200"></el-table-column>
        <el-table-column v-if="system_setting.IsChargeDecoupling" :key="'remark'" prop="remark" show-overflow-tooltip label="失败原因"  min-width="200">
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="system_setting.IsChargeDecoupling" :key="'right'" fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.tableState==0||scope.row.tableState==2" v-preventReClick @click="generateOrder(scope.row)" class="margin-left20 color-blue">生成单据</el-button>
        </template>
      </el-table-column>
      </el-table>
    </div>
   
    </div>
    <div class="pagination">

      <span style="float: left">勾选金额合计：{{ totalAmount }}元 &nbsp; 勾选数量合计：{{totalNumber}} </span>
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>
 
<script>
import {
  GetHisChargeLogs,
  ExportChargeLogs,
  GetHisChargeLogPrintData,
  SendChargeLogTableGeneration
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
// import SelectTree from '@/components/select-tree'
import {
  ChargeStateOptions,
  ChargeCategoryOptions,
  StockCategoryOptions,
  TableStateOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
 
export default {
  mixins: [GetDataMixin, GetDataSpdMixin,BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      exportAction: ExportChargeLogs,
      PrintAction: GetHisChargeLogPrintData,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      totalNumber: 0,
      // 列表多选
      multiple: true,
      editMode: false,
      ChargeStateOptions: ChargeStateOptions,
      ChargeCategoryOptions: ChargeCategoryOptions,
      StockCategoryOptions: StockCategoryOptions,
      TableStateOptions:TableStateOptions,
      filterOptions: [{
        name: "计费单号",
        type: "input",
        code: "chargeNo",
      },
      {
        name: "计费人",
        type: "input",
        code: "userName",
      },
      {
        name: "计费科室",
        type: "select",
        code: "hisDeptId",
        filterMethod: this.getDeptList,
        data: [],
      },
      {
        name: "执行科室",
        type: "select",
        code: "deptId",
        filterMethod: this.getDeptList,
        data: [],
      },
      {
        name: "计费类型",
        type: "select",
        code: "Categorys",
        data: ChargeCategoryOptions,
        multiple:true
      },
      {
        name: "住院号/病历号",
        type: "input",
        code: "patientNo",
      },
      {
        name: "患者",
        type: "input",
        code: "patientName",
      },
      {
        name: "库存类型",
        type: "select",
        code: "StockCategory",
        data: StockCategoryOptions,
      },
      {
        name: "产品",
        type: "select",
        code: "supplierProductId",
        filterMethod: this.getSupplierProductsNoDebounce,
        data: [],
      },
      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
      // {
      //   name: "计费时间",
      //   type: "date",
      //   code: "date",
      // },
      {
        name: "核销时间",
        type: "datetimerange",
        code: "createdDate",
        format:'yyyy-MM-dd HH:mm:ss',
        startDateCode: "startCreatedDate",
        endDateCode: "endCreatedDate",
      },
      {
        name: "医保代码",
        type: "input",
        code: "medicalInsuranceCategoryNo",
      },
      {
        name: "补单状态",
        type: "select",
        code: "tableState",
        data: TableStateOptions,
      },
      {
        name: "标签码",
        type: "input",
        code: "tagCode",
      },
      {
        name: "部件部位",
        type: "input",
        code: "componentLocation",
      },
      ],
      remarkVisible: false,
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
      if (selection) {
        this.totalAmount = 0
        this.totalNumber = 0
        selection.forEach(item => {
          this.totalAmount += item.amount
          this.totalNumber += item.number
        })
      }
      this.totalAmount = this.totalAmount.toFixed(3) * 1
    },
    // 获取列表
    getData () {
      GetHisChargeLogs(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 打印
    print (command) {
      this.query.type = command;
      GetHisChargeLogPrintData(this.query).then((res) => {
        var result = res.returnData;
 
        var printData = this.printDataConvert(result.printData);
        this.sendPrintMessage(JSON.stringify(printData));
      });
    },
 
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
 
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        endDate:'',
        startDate:'',
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;
 
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },
    generateOrder(row){
      this.$message({
          message: '请求发送成功，请稍后刷新查看数量',
          type: 'success'
        });
      SendChargeLogTableGeneration({chargeLogId:row.id})
    },
    getDeptList (keyWord) {
      return new Promise((resolve, reject) => {
        this.getDepts(keyWord).then((response) => {
          if (response) {
            response.map((i) => {
              i.id = i.hisDeptId;
              return i;
            });
            resolve(response);
          } else {
            reject(response);
          }
        });
      });
    },
  },
  mounted () {
    // this.getData();
  },
};
</script>
 
<style lang="scss" scoped></style>